(function () {
  'use strict';

  var TOTAL_STEPS = 5;
  var SELECT_FLASH_MS = 220;

  function init(section) {
    if (!section || section.dataset.tmnReady === 'true') return;
    section.dataset.tmnReady = 'true';

    var quiz = section.querySelector('[data-tmn-quiz]');
    var viewport = section.querySelector('[data-tmn-viewport]');
    if (!quiz || !viewport) return;

    var panels = Array.prototype.slice.call(viewport.querySelectorAll('.tmn-panel'));
    var answers = {};
    var history = [];
    var current = viewport.querySelector('.tmn-panel.is-active') || panels[0];
    var busy = false;

    var reduced = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setHeight(panel) {
      if (!panel) return;
      viewport.style.height = panel.offsetHeight + 'px';
    }

    function panelByStep(n) {
      return viewport.querySelector('.tmn-step[data-step="' + n + '"]');
    }

    function stepNumber(panel) {
      return panel && panel.dataset.step ? parseInt(panel.dataset.step, 10) : 0;
    }

    function focusPanel(panel) {
      var target = panel.querySelector('.tmn-option, .tmn-start-btn, .tmn-result-btn');
      if (target && typeof target.focus === 'function') {
        target.focus({ preventScroll: true });
      }
    }

    function keepInView() {
      var rect = section.getBoundingClientRect();
      if (rect.top < 0) {
        window.scrollTo({
          top: window.pageYOffset + rect.top - 16,
          behavior: reduced ? 'auto' : 'smooth'
        });
      }
    }

    function goTo(next, reverse) {
      if (!next || next === current || busy) return;
      busy = true;

      quiz.classList.toggle('is-reversing', !!reverse);

      var outgoing = current;
      setHeight(outgoing);

      requestAnimationFrame(function () {
        outgoing.classList.remove('is-active');
        outgoing.classList.add('is-leaving');
        next.classList.add('is-active');

        requestAnimationFrame(function () {
          setHeight(next);
        });

        window.setTimeout(function () {
          outgoing.classList.remove('is-leaving');
          quiz.classList.remove('is-reversing');
          current = next;
          setHeight(next);
          busy = false;
          focusPanel(next);
        }, reduced ? 0 : 420);
      });

      keepInView();
    }

    function buzz() {
      if (navigator.vibrate && window.matchMedia('(pointer: coarse)').matches) {
        navigator.vibrate(8);
      }
    }

    var startBtn = section.querySelector('[data-tmn-start]');
    if (startBtn) {
      startBtn.addEventListener('click', function () {
        buzz();
        goTo(panelByStep(1), false);
      });
    }

    section.querySelectorAll('.tmn-option').forEach(function (option) {
      option.addEventListener('click', function () {
        if (busy) return;

        var step = this.closest('.tmn-step');
        var n = stepNumber(step);

        step.querySelectorAll('.tmn-option').forEach(function (o) {
          o.classList.remove('is-selected');
        });
        this.classList.add('is-selected');
        buzz();

        answers[this.dataset.question] = this.dataset.value;
        history.push(n);

        window.setTimeout(function () {
          if (n < TOTAL_STEPS) {
            goTo(panelByStep(n + 1), false);
          } else {
            showResult();
          }
        }, reduced ? 0 : SELECT_FLASH_MS);
      });
    });

    section.querySelectorAll('[data-tmn-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (busy) return;
        var n = stepNumber(this.closest('.tmn-step'));
        history.pop();
        if (n > 1) {
          goTo(panelByStep(n - 1), true);
        } else {
          goTo(viewport.querySelector('[data-panel="intro"]'), true);
        }
      });
    });

        section.querySelectorAll('[data-tmn-skip]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (busy) return;
        answers = {};
        history = [];
        section.querySelectorAll('.tmn-option.is-selected').forEach(function (o) {
          o.classList.remove('is-selected');
        });
        goTo(viewport.querySelector('[data-panel="intro"]'), true);
      });
    });

    function pickResult() {
      var counts = { A: 0, B: 0, C: 0 };
      Object.keys(answers).forEach(function (k) {
        if (counts[answers[k]] !== undefined) counts[answers[k]]++;
      });

      if (counts.A > counts.B && counts.A > counts.C) return 'late_checkout';
      if (counts.B > counts.A && counts.B > counts.C) return 'bottled_blooms';
      if (counts.C > counts.A && counts.C > counts.B) return 'rare_oud';
      if (counts.A === counts.B && counts.A > counts.C) return 'bottled_blooms';
      if (counts.B === counts.C && counts.B > counts.A) return 'rare_oud';
      if (counts.A === counts.C && counts.A > counts.B) return 'late_checkout';
      return 'rare_oud';
    }

    function money(paise) {
      if (!paise) return '';
      var value = paise / 100;
      try {
        return new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: 'INR',
          maximumFractionDigits: 0
        }).format(value);
      } catch (e) {
        return '\u20B9' + Math.round(value);
      }
    }

    function showResult() {
      var key = pickResult();
      var products = window.tmnProducts || {};
      var result = products[key];
      var panel = viewport.querySelector('[data-panel="result"]');
      var errorEl = section.querySelector('[data-tmn-error]');

      if (!result || !result.title) {
        console.warn('[tmn-scent-finder] No product configured for result:', key);
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = 'We could not load your match. Browse all scents instead.';
        }
        goTo(panel, false);
        return;
      }

      if (errorEl) errorEl.hidden = true;
      window.tmnCurrentResult = result;

      var titleEl = section.querySelector('#tmn-result-title');
      var descEl = section.querySelector('#tmn-result-description');
      var imgEl = section.querySelector('#tmn-result-image');
      var atcLabel = section.querySelector('[data-atc-label]');

      if (titleEl) titleEl.textContent = result.title;
      if (descEl) descEl.innerHTML = result.description || '';

      if (atcLabel && result.price) {
        atcLabel.textContent = (result.available === false)
          ? 'Sold out'
          : 'Add to cart \u00B7 ' + money(result.price);
      }

      if (imgEl) {
        imgEl.classList.remove('is-loaded');
        if (result.image) {
          imgEl.onload = function () {
            imgEl.classList.add('is-loaded');
            setHeight(panel);
          };
          imgEl.onerror = function () {
            imgEl.style.display = 'none';
            setHeight(panel);
          };
          imgEl.style.display = '';
          imgEl.src = result.image;
          imgEl.alt = result.title;
        } else {
          imgEl.style.display = 'none';
        }
      }

      goTo(panel, false);
    }

    var retakeBtn = section.querySelector('#tmn-retake-btn');
    if (retakeBtn) {
      retakeBtn.addEventListener('click', function () {
        answers = {};
        history = [];
        section.querySelectorAll('.tmn-option.is-selected').forEach(function (o) {
          o.classList.remove('is-selected');
        });
        goTo(viewport.querySelector('[data-panel="intro"]'), true);
      });
    }

    var atcBtn = section.querySelector('#tmn-atc-btn');
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        var result = window.tmnCurrentResult;
        var errorEl = section.querySelector('[data-tmn-error]');
        if (!result || !result.variant_id) return;

        atcBtn.setAttribute('aria-busy', 'true');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: result.variant_id, quantity: 1 })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Cart add failed');
            window.location.href = '/cart';
          })
          .catch(function () {
            atcBtn.removeAttribute('aria-busy');
            if (errorEl) {
              errorEl.hidden = false;
              errorEl.textContent = 'Could not add that to your cart. Try the product page.';
            }
          });
      });
    }

    var buyBtn = section.querySelector('#tmn-buy-now-btn');
    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        var result = window.tmnCurrentResult;
        if (result && result.url) window.location.href = result.url;
      });
    }

    setHeight(current);

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        setHeight(current);
      }, 120);
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { setHeight(current); });
    }
  }

  function boot() {
    document.querySelectorAll('[data-tmn-scent-finder]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-tmn-scent-finder]');
    if (section) init(section);
  });
})();